import { NavLink, useLocation, useParams } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import { API_BASE_URL, DEFAULT_PAGE_DESCRIPTION, DEFAULT_PAGE_TITLE } from "../../utilities/constants";
import { useEffect, useState } from "react";
import LookCards from "./LookCards";
import { dobToAge, formatHeightUnit, handleApiCall } from "../../utilities/helper";
import Spinner from "../../components/ui/Spinner";
import GeneratedLooksCard from "../generatedlooks/GeneratedLooksCard";

const LookGenerationDetails = () => {
    const location = useLocation();
    const { jobId, profile } = location.state || {};
    const { stylist } = location.state || {};
    const [lookData, setLookData] = useState(null);
    const [data , setData] = useState(null);
    const profileData = data || profile;
    const [loading, setLoading] = useState(false);
    const [controller, setController] = useState(null);
     const { id } = useParams();

     const callUserApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/customer/v2/${id}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
                return true;
            } else {
                setData(null);
                // return false;
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };

    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/aigenlook/v2/look-job/${jobId}`,//124 127
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setLookData(response.data);
                return true
            } else {
                setLookData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callUserApi();
        if (!jobId) return;
        callListApi();
    }, [location.search, jobId]);


    return (
        <>
            <PageMeta
                title={`Look Generation - ${DEFAULT_PAGE_TITLE}`}
                description={`Look Generation - ${DEFAULT_PAGE_DESCRIPTION}`}
            />

            <div className="flex justify-between items-center mb-4">
                <PageBreadcrumb
                    pageTitle="Look Generation"
                    breadcrumbs={[
                        { label: "Customer", path: "/customers" },
                        { label: "customers Details", path: `/customers-details/${profileData?.profile?.id}` },
                        { label: "Look Details" },
                    ]}
                />
                <NavLink to={`/look-generation/${profileData?.profile?.id}`} state={{ data }}>
                    <button
                        type="submit"
                        className="bg-yellow-600 text-white px-6 py-2 rounded-md hover:bg-yellow-700 transition"
                    >
                        Generate New Looks
                    </button>
                </NavLink>
            </div>

            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <>
                    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl mb-8">
                        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6">

                            <img
                                src={
                                    profileData?.profile?.profile?.profileDpSignedUrl
                                        ? profileData.profile?.profile?.profileDpSignedUrl
                                        : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                            `${profileData?.profile?.firstName || ""} ${profileData?.profile?.lastName || ""}`
                                        )}&background=a8936a&color=fff`
                                }
                                alt={`${profileData?.profile?.firstName} ${profileData?.profile?.lastName}`}
                                className="w-28 h-28 rounded-full object-cover border-2 border-gray-300 dark:border-gray-700"
                            />

                            <div className="flex-1">
                                <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-1">
                                    {`${profileData?.profile?.firstName || ""} ${profileData?.profile?.lastName || ""}`}
                                </h2>
                                <p className="text-gray-600 dark:text-gray-300 mb-2">
                                    {profileData?.profile?.email || "No email provided"}
                                </p>

                                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-4">
                                    <div>
                                        <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Age</p>
                                        <p className="font-medium text-gray-800 dark:text-gray-100">{dobToAge(profileData?.profile?.profile?.dob) || "0"} <span className="text-sm font-normal">YEARS</span></p>
                                    </div>
                                    <div>
                                        <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Gender</p>
                                        <p className="font-medium text-gray-800 dark:text-gray-100 capitalize">{profileData?.profile?.profile?.gender || "-"}</p>
                                    </div>
                                    <div>
                                        <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Height</p>
                                        <p className="font-medium text-gray-800 dark:text-gray-100">{profileData?.profile?.profile?.height || 0} <span className="text-sm font-normal">{formatHeightUnit(data?.profile?.profile?.heightUnit) || "CM"}</span></p>
                                    </div>
                                    <div>
                                        <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Weight</p>
                                        <p className="font-medium text-gray-800 dark:text-gray-100">{profileData?.profile?.profile?.weight || 0} <span className="text-sm font-normal">{profileData?.profile?.profile?.weightUnit || "KG"}</span></p>
                                    </div>
                                    <div>
                                        <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Shoe Size</p>
                                        <p className="font-medium text-gray-800 dark:text-gray-100">{profileData?.profile?.profile?.shoeSize || 0} <span className="text-sm font-normal">{profileData?.profile?.profile?.shoeSizeUnit || "CM"}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-gray-50 dark:bg-gray-900 rounded-xl ">

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                            {lookData?.looks?.map((look) => (
                                <GeneratedLooksCard key={look?.lookId || look?.jobId} look={look} stylist={stylist} />
                            ))}

                        </div>
                    </div>
                </>
            )}
        </>
    );
}
export default LookGenerationDetails;